import React from 'react';
import { SelectInput } from 'react-admin';
import dataProviderFactory from '../../dataProvider'
import { GET_LIST } from 'react-admin'
import { prop } from 'ramda'
export class GenericInputFilter extends React.Component  {

    constructor(props) {
      super(props);
      this.offset = 0
      this.state = { data: [] }
    }
  
    async getModelsData() {
        let data = []
        const dataProvider = await dataProviderFactory('rest')
        const response = await dataProvider(GET_LIST, this.props.search_resource, { pagination: {
            page: 1,
            perPage: 999,
        },
        sort: { field: this.props.resource_field, order: 'asc' } })
        
        const _this = this
        response.data.map(function (item) {
          return data.push({id: item.id, [`${_this.props.resource_field}`]: prop(_this.props.resource_field, item) })
        });

        return data
    } 

    componentWillReceiveProps(nextProps) {
      if (nextProps.input.value !== this.props.input.value) {
          this.setState({ value: nextProps.input.value });
      }
    }

    async componentDidMount() {
      const dataItems = await this.getModelsData()
      const data = {data: dataItems}
      this.setState(data)
    }
    render() {
      return ( 
        <div>
          <span>
            <SelectInput
                source= {this.props.resource_id}
                choices={this.state.data}
                {...this.rest}
                optionText= {this.props.resource_field}
                optionValue="id"
                allowEmpty={true}
                defaultValue={null}
            />
          </span>
        </div>
      )
    }
  }


// WEBPACK FOOTER //
// ./src/components/selectboxfilter/genericInputFilter.js